/**
 * Journal Entries (BE-16) — real API.
 *
 * List: newest first, server-paged, filtered by source types (several allowed), date range and account. Detail: one
 * entry with its lines. Manual journals and their reversal are TC_ADMIN only; the chart for the form flags accounts
 * closed to manual lines and those needing a VAT base.
 */

import ApiService from '../api.service';
import { keysCamelToSnake, unwrapData, unwrapList, unwrapPage } from '../../utils/apiConvert';

const clean = (obj) => Object.fromEntries(Object.entries(obj || {}).filter(([, v]) => v !== '' && v !== undefined && v !== null));

export const journalEntryService = {
  // params: { sourceTypes: [], from, to, account, page, size }
  getAll: async ({ sourceTypes, ...rest } = {}) =>
    unwrapPage(await ApiService.get('/api/journal-entries', {
      params: clean({ ...rest, sourceType: sourceTypes?.length ? sourceTypes.join(',') : undefined }),
    })),

  getById: async (id) => unwrapData(await ApiService.get(`/api/journal-entries/${id}`)),

  // data: { entryDate, description, idempotencyKey, lines: [{ accountId, debit | credit, description, vatBase }] }
  createManual: async (data) =>
    unwrapData(await ApiService.post('/api/journal-entries/manual', keysCamelToSnake(data))),

  reverse: async (id, reason) => unwrapData(await ApiService.post(`/api/journal-entries/${id}/reverse`, { reason })),

  getGlAccounts: async () => unwrapList(await ApiService.get('/api/gl-accounts')).items,
};

export default journalEntryService;
